/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Currency_Jpy3Inputs */

const he_currency_jpy3 = /** @type {(inputs: Currency_Jpy3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JPY - Japanese Yen`)
};

const en_currency_jpy3 = /** @type {(inputs: Currency_Jpy3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JPY - Japanese Yen`)
};

/**
* | output |
* | --- |
* | "JPY - Japanese Yen" |
*
* @param {Currency_Jpy3Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const currency_jpy3 = /** @type {((inputs?: Currency_Jpy3Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Currency_Jpy3Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_currency_jpy3(inputs)
	return en_currency_jpy3(inputs)
});
export { currency_jpy3 as "currency_JPY" }